import axios, { AxiosInstance } from 'axios'

const origin = window.location.origin

const instance: AxiosInstance = axios.create({
    baseURL: origin + '/services/plugin-liverig/',
    headers: { 'Content-Type': 'application/json' }
})

export default instance
